module.exports = __webpack_public_path__ + "img/sf.ef24edec.png";